<script lang="ts">
	import {uqnArray} from './stores';
	import {get} from 'svelte/store'
	let tysCredit = { // change this
		year: "",
		paper: "",
		qn: ""
	}
	import Button, {Label} from '@smui/button';
	import random from './check_random/random';
	import Dialog, {Title as DialogTitle, Content as DialogContent, Actions} from '@smui/dialog';
	let simpleDialog;
	function dialogHandler() {
		simpleDialog.open();
	}
</script>

<p>
	Click on the button below to access the UQNs (unique question numbers) for this question.<br>
	On your next visit you can use a UQN to return to a specific question under the options tab.
</p>
<Button on:click={dialogHandler} variant="unelevated" class="button-shaped-round">
	<Label> Access UQNs</Label>
</Button>	
<hr>
{#if tysCredit.year}
<p> This question is inspired by the {tysCredit.year} A Levels H2 Mathematics Paper {tysCredit.paper} Question {tysCredit.qn}</p>
{/if}
<Dialog bind:this={simpleDialog}>
	<DialogTitle>UQNs</DialogTitle>
	<DialogContent>
		The UQNs for each part:
		<div style="margin-left:1rem">
			{#each $uqnArray as uqn, id}
				<br> <tt>({String.fromCharCode(id+97)}) {uqn} </tt>
			{/each}
		</div>
	</DialogContent>
	<Actions>
		<Button>
			<Label>OK</Label>
		</Button>
	</Actions>
</Dialog> 
